module.exports = __webpack_public_path__ + "img/logo-with-name.50fe6994.png";